// extracted by css-extract-rspack-plugin
export default {"cls1":"PackPreviewRows-cls1_z6k","cls2":"PackPreviewRows-cls2_hu5 PackPreviewRows-cls1_z6k","size-v2":"PackPreviewRows-size-v2_dBO","tone-card":"PackPreviewRows-tone-card_MhD"};